// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__11Erm","faq__header":"FAQ_faq__header__JbxXA","faq__items":"FAQ_faq__items__3QLUx"};